import { Footer, NavBar } from '@/components/index'

import PropTypes from 'prop-types'
import UnlockCardStaticBanner from '@/pages/account-page/tabs/manage-card/unlock-card-static-banner.jsx'
import PersistentHeaderBanner from '../persistent-header-banner'
import PlaidUpdateModal from '../plaid-update-modal'
import useZendesk from '@/hooks/use-zendesk'
import FinancialAccountDelinquentSuspendedBanner from '../financial-account-delinquent-suspended-banner'
import usePlaidItems from '@/pages/hooks/use-plaid-items'
import FinancialAccountClosedBanner from '../financial-account-closed-banner'
import PlaidLinkSingleton from '@/components/plaid-link-singleton'
import { useLocation } from 'react-router'
import { useEffect, useRef, useState } from 'react'

const FOOTER_HIGHT = 220

const PrivateLayout = ({ children, setIsLoading }) => {
  //Use the custom hook
  useZendesk()
  const { pathname } = useLocation()
  const isHome = pathname?.includes('home')

  // Check if Plaid components are needed
  const { needsReconnection, showPlaidBannerType } = usePlaidItems()

  const bannerContainerRef = useRef(null)
  const [bannerHigh, setBannerHight] = useState(0)
  useEffect(() => {
    if (!bannerContainerRef.current) return
    const el = bannerContainerRef.current
    const observer = new ResizeObserver(entries => {
      const height = entries[0].contentRect.height
      // Detect banner by container hight
      setBannerHight(height)
    })
    observer.observe(el)
    return () => observer.disconnect()
  }, [])

  const shouldShiftChildren = bannerHigh > 25
  const totalContentHightOtherThanOutlet = FOOTER_HIGHT + bannerHigh

  return (
    <div className="relative min-h-screen flex flex-col">
      <NavBar />
      <div ref={bannerContainerRef} className="max-md:relative max-md:z-10">
        <FinancialAccountDelinquentSuspendedBanner />
        <FinancialAccountClosedBanner />
        <UnlockCardStaticBanner />
        <PersistentHeaderBanner setIsLoading={setIsLoading} bannerType={showPlaidBannerType} />
      </div>
      <div
        className={`${isHome && shouldShiftChildren ? 'max-md:-mt-[120px] max-md:relative' : ''}`}
        style={{
          '--offset': `${totalContentHightOtherThanOutlet}px`,
        }}
      >
        {children}
      </div>
      <div id="sticky-bar-portal-target" />
      <Footer />
      {needsReconnection && <PlaidUpdateModal />}
      <PlaidLinkSingleton />
    </div>
  )
}

PrivateLayout.propTypes = {
  children: PropTypes.node.isRequired,
  setIsLoading: PropTypes.func,
}

export default PrivateLayout
